module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mt-header', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "width": "100%",
      "z-index": "1000"
    },
    attrs: {
      "title": "实名认证"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "soSorry"
  }, [_vm._v("很遗憾，实名认证申请失败！")]), _vm._v(" "), _c('div', {
    staticClass: "youCan"
  }, [_vm._v("您可以"), _c('span', {
    on: {
      "click": _vm.recertification
    }
  }, [_vm._v("重新实名认证")])]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.recertification
    }
  }, [_vm._v("重新认证")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e01bc418","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/realName/realNameFailed.vue
// module id = 1301
// module chunks = 1